import { FC } from "react";

interface PortfolioProps {}

interface GPTItem {
  name: string;
  description: string;
  url: string;
  icon: string;
}

const Portfolio: FC<PortfolioProps> = () => {
  const gptItems: GPTItem[] = [
    {
      name: 'Nearby Places',
      description:
        'Discover interesting places around you with this custom GPT that helps you find restaurants, attractions, and local spots based on your location and preferences.',
      url: 'https://chatgpt.com/g/g-a7I4NqZ7p-nearby-places',
      icon: 'fa-map-marker-alt'
    },
    {
      name: 'BIXI Montreal',
      description:
        "Your personal assistant for Montreal's bike-sharing system. Get real-time station availability, plan your routes, and make the most of BIXI in Montreal.",
      url: 'https://chatgpt.com/g/g-MV30pvRr4-bixi-montreal',
      icon: 'fa-bicycle'
    },
    {
      name: 'STM Montreal',
      description:
        "Navigate Montreal's public transit system with ease. Get schedules, plan trips, and stay updated on service alerts for buses and metro lines.",
      url: 'https://chatgpt.com/g/g-686295a41b08819185d2d40d38b978c3-stm-montreal',
      icon: 'fa-bus'
    }
  ]

  return (
    <div
      className="bloc d-bloc bloc-fill-screen bloc-bg-texture texture-darken-strong"
      id="portfolio-section"
    >
      <div className="container">
        <div className="row">
          <div className="offset-lg-1 col-lg-10">
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h1 className="mg-md text-lg-center h1-about-style text-white">
                  Portfolio
                </h1>
              </div>
            </div>
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h2 className="mg-md text-lg-center h3-about-style text-white fix-header">
                  Custom GPTs powered by ChatGPT
                </h2>
              </div>
            </div>
            <p className="text-lg-center p-7-style scroll-fx-up-in mt-md-4 mt-sm-2">
              Explore our collection of custom GPTs designed to enhance daily
              experiences in Montréal and beyond. These AI-powered assistants
              leverage the reasoning capabilities of ChatGPT while being
              grounded in real-world data through a dedicated API developed in
              .NET Core and hosted on Microsoft Azure. Rather than relying
              solely on language models, each assistant integrates with backend
              services that handle domain-specific logic, data retrieval, and
              validation—ensuring responses are accurate, contextual, and
              actionable. This architecture makes it possible to combine
              conversational AI with live systems, open data sources, and custom
              business rules, delivering assistants that behave like true
              applications rather than generic chatbots.
            </p>
          </div>
        </div>
        <div className="row justify-content-center">
          {gptItems.map((item, index) => (
            <div
              key={index}
              className={`col-md-4 col-lg-3 ${index > 0 ? 'mt-3 mt-md-0' : ''} d-flex align-self-stretch animated zoomIn`}
              data-appear-anim-style="zoomIn"
            >
              <div className="card w-100">
                <div className="card-header text-center">
                  <i
                    className={`fas ${item.icon} fa-3x mb-2`}
                    aria-hidden="true"
                  ></i>
                  <h3 className="mg-clear text-center h3-languages-style">
                    {item.name}
                  </h3>
                </div>
                <div className="card-body d-flex flex-column">
                  <p className="text-center p-style flex-grow-1">
                    {item.description}
                  </p>
                  <div className="text-center mt-auto">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-lg btn-wire"
                    >
                      <i className="fas fa-external-link-alt me-2"></i>
                      &nbsp;&nbsp;Try it now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
};

export default Portfolio;
